module.exports = __webpack_public_path__ + "img/image-2AzOSQ9.png";